import { FileDesc, Post, Upload, UploadType } from '@wellesley/openapi'
import { MutableRefObject } from 'react'

export enum UploadStatus {
  done = 'done',
  inprogress = 'inprogress',
}

export type UploadItem = {
  id: string
  meta: Upload['meta']
  type: UploadType
  sizes: {
    width: FileDesc['meta']['width']
    height: FileDesc['meta']['height']
  }
  preview: string
  status: UploadStatus
  upload: Promise<string>
  progress: number
  cancel: () => void
  isError?: boolean
  duration?: number | null
  uploadId?: string
}

export enum UploadTag {
  post = '$post',
  album = '$album',
  avatar = '$avatar',
  header = '$header',
  emoji = '$emoji',
}

export type UseUploadMediaProps = {
  feed?: Post
  previewSize?: number
  closeCb?: MutableRefObject<(() => void) | undefined>
  resetOnClose?: boolean
  onMediaChange?: (count: number) => void
}

export type UploadFileProps = {
  file: File
  objectUrl: string
}

export type MediaUpload =
  | (Upload & {
      progress?: number
    })
  | UploadItem

export type Sizes = {
  width: number
  height: number
}
